/**
 * What the price does and does not include, in two tinted boxes. The text is
 * typed into a plain textarea in the backoffice, so its line breaks are the
 * only formatting it has. Nothing for an event that leaves both blank -- the
 * caller leaves the section out (hasPriceCoverage).
 */
import type { EventDetails } from "@/lib/types/event";

type Coverage = Pick<EventDetails, "price_includes" | "price_excludes">;

export const hasPriceCoverage = (event: Coverage | null | undefined) =>
  !!event && (!!String(event.price_includes || "").trim() || !!String(event.price_excludes || "").trim());

function Box({ tone, title, text }: { tone: "included" | "excluded"; title: string; text: string | null | undefined }) {
  const value = String(text || "").trim();
  if (!value) {
    return null;
  }
  return (
    <div className={`rounded-[12px] px-4 py-3 ${tone === "included" ? "bg-[hsl(141,49%,93%)]" : "bg-[hsl(4,75%,95%)]"}`}>
      <p className="text-[13px] font-bold">{title}</p>
      <p className="mt-1 whitespace-pre-line text-[13.5px] leading-relaxed text-ink-soft">{value}</p>
    </div>
  );
}

export function PriceCoverage({ event, className = "" }: { event: Coverage; className?: string }) {
  if (!hasPriceCoverage(event)) {
    return null;
  }
  return (
    <div className={`flex flex-col gap-2.5 ${className}`}>
      <Box tone="included" title="Incluído no preço" text={event.price_includes} />
      <Box tone="excluded" title="Não incluído no preço" text={event.price_excludes} />
    </div>
  );
}
